var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMau = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-mau_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.962 1.137a1 1 0 0 1 1.393.246l2.162 3.092 2.151-3.09a1 1 0 0 1 1.547-.116 1 1 0 0 1 .304.718v6.012a1 1 0 1 1-2 0V5.1L5.504 6.56a1.2 1.2 0 0 1-1.969.001L2.52 5.107V8a1 1 0 1 1-2 0V1.987c0-.178.047-.345.128-.49a1 1 0 0 1 .315-.36m5.574 10.924a1 1 0 1 1 2 0v6.983h-2zM4.51 13.2a1 1 0 0 0-1 1v4.843h2V14.2a1 1 0 0 0-1-1m-3.028 2.79a1 1 0 0 0-1 1v2.053h2V16.99a1 1 0 0 0-1-1M16.286 5.519l-.772-1.69-.773 1.69zm.915 2 .408.894a1 1 0 0 0 1.82-.831l-2.642-5.777c-.499-1.09-2.048-1.09-2.547 0L11.6 7.582a1 1 0 0 0 1.819.831l.409-.894zm-3.316 4.549a1 1 0 0 0-2 0v3.414a3.629 3.629 0 1 0 7.257 0v-3.414a1 1 0 0 0-2 0v3.414a1.629 1.629 0 0 1-3.257 0z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-mau_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIconMau;